import { useEffect } from 'react';

/**
 * @type {import('.').UseTrapTabType}
 */
const useTrapTab = ({ ref, enabled }) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const focusableElementSelector = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(', ');

    const listener = (e) => {
      if (e.key !== 'Tab') {
        return;
      }
      // run query selector inside listener to use lastest children of reference
      const focusableElements = Array.from(ref.current.querySelectorAll(focusableElementSelector));

      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
        return;
      }

      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [ref, enabled]);
};

export default useTrapTab;
